var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":_vm.title,"visible":_vm.drawer,"direction":_vm.direction,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.drawer=$event}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }